import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.white};
  margin-bottom: 2rem;
  margin-top: 2rem;
  padding: 0 1rem;
  max-width: 650px;
  align-self: center;
`;

const Text = styled.span`
  font-size: ${({ theme }) => theme.fontSize.extraSmall};
  text-align: center;
  color: rgba(255, 255, 255, 0.75);
`;

const PlanTerms: React.FC = () => {
  return (
    <Container>
      <Text>
        Annual subscriptions are backed by our 60 day money back guarantee. Applicable VAT, sales or
        other taxes may apply. To cancel, go to your Account Overview and click on the membership
        button
      </Text>
    </Container>
  );
};

export default PlanTerms;
